module.exports = __webpack_public_path__ + "img/big_1_19.d0a06636.png";